import { QueryResult, useQuery, useQueryCache } from "react-query";
import fetchApi from "../backend/fetchApi";
import { usePlayer } from "../player/playerContext";
import { CouponShare } from "../models/couponshares";

const usePublicCouponShare = (publicCouponShareId: string) => {

    const [player] = usePlayer() as any;
    const queryCache = useQueryCache();
    let couponShareUrl = player && player._links.rounds.href;
    if (couponShareUrl) {
        couponShareUrl = couponShareUrl.replace("rounds", "publicCouponShares");
        couponShareUrl += "/" + publicCouponShareId;
    }

    const key = 'couponShare' + publicCouponShareId;

    let result = useQuery<CouponShare, unknown>([key, couponShareUrl], () => {

        return fetchApi(couponShareUrl)
            .then(response => response.json()).then(r => {
                return r;
            })
            .catch(err => {
                return null;
            })
    }
        , {
            enabled: !!player && !!publicCouponShareId,
            initialStale: true,
        })

    const reloadCouponShare = () => queryCache.invalidateQueries([key, couponShareUrl]);

    return [
        result.data,
        { ...result, reloadCouponShare }
    ] as [CouponShare | undefined, QueryResult<CouponShare> & {
        reloadCouponShare: () => Promise<any>
    }]
}

export default usePublicCouponShare;
